import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export function DropDownWithSearch({ optionValue, options, value, name, label, disabled, required, fullWidth, helperText, className,
    onChange, error, loadingValue, hideClearIcon }) {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loadingValue) {
            setLoading(true)
        }
        else {
            setLoading(false)
        }
    });

    return (
        <div className=''>
            <Autocomplete
                options={options}
                value={value ? value : null}
                getOptionLabel={(option) => option[optionValue ? optionValue : 'name']}
                onChange={onChange}
                name={name}
                loading={loading}
                disabled={disabled}
                disableClearable={hideClearIcon ? true : false}
                onInputChange={async (event, value) => {
                    if (!value) return;
                    setLoading(true);
                    await sleep(1000);
                    setLoading(false);
                }}
                renderInput={(params) => {
                    params.inputProps.autoComplete = 'new-password';
                    return <TextField {...params}
                        label={label}
                        className={className}
                        required={required}
                        fullWidth={fullWidth}
                        variant="outlined"
                        helperText={error ? error : helperText}
                        error={error}
                    />
                }}
            />
        </div>
    );
}